module.exports = __webpack_public_path__ + "img/linkedinLogo.2d8dca1a.svg";